import { SxProps } from '@mui/material';

export const listCellContainerSx: SxProps = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
  width: '100%',
  justifyContent: 'flex-start',
  position: 'relative',
};

export const listCellTextSx = (
  showEllipsis: boolean,
  shouldReserveActionSpace: boolean
): SxProps => ({
  overflow: 'hidden',
  textOverflow: showEllipsis ? 'ellipsis' : 'clip',
  whiteSpace: 'nowrap',
  flex: 1,
  minWidth: 0,
  textAlign: 'left',
  ...(shouldReserveActionSpace
    ? {
        maxWidth: 'calc(100% - 72px)',
      }
    : {}),
});

export const listCellMobileTextSx: SxProps = {
  whiteSpace: 'normal',
  wordBreak: 'break-word',
};

export const listCellDialogTitleSx: SxProps = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  pb: 1,
};

export const listCellChipSx: SxProps = {
  flexShrink: 0,
};

export const listCellDialogPaperSx: SxProps = {
  borderRadius: 2,
};

export const listCellCloseButtonSx: SxProps = {
  p: 0.5,
};
